import React from "react";
import styled from "styled-components";
import { Heading, SubHeading } from "./components/styles";

const Container = styled.section`
  padding: 63px 25px;
`;

const DemoBox = styled.div`
  width: 594px;
  height: 988px;
  margin: 90px auto 0;

  @media screen and (max-width: 500px) {
    margin: 24px auto 0;
    width: 308px;
    height: 473px;
  }
`;

function Demo() {
  return (
    <Container id="demo">
      <Heading center secondary>
        Get a <span> Demo</span>
      </Heading>
      <SubHeading center margin="20px" subHeading>
        Schedule a time for us show you our APIs in action.
      </SubHeading>
      <DemoBox>
        <iframe
          src="https://calendly.com/authenticating/demo?embed_domain=www.authenticating.com&amp;embed_type=Inline"
          width="100%"
          height="100%"
          frameBorder="0"
          title="Schedule a time with us to see our API’s in action."
        ></iframe>
      </DemoBox>
    </Container>
  );
}

export default Demo;
